import { createFileRoute } from '@tanstack/react-router';

import { DeliveryCompareView } from '~/features/catalog-operations/pages/delivery-compare-page';
import { RequireChannelConnection } from '~/features/onboarding/components/require-channel-connection';
import { requireFeatureGate } from '~/utils/guards';

export const Route = createFileRoute(
  '/_authenticated/_tenant/catalog-operations/$batchId_/compare-delivery',
)({
  beforeLoad: requireFeatureGate('compare-delivery'),
  component: RouteComponent,
});

function RouteComponent() {
  const { batchId } = Route.useParams();
  return (
    <RequireChannelConnection>
      <DeliveryCompareView batchId={batchId} />
    </RequireChannelConnection>
  );
}
